export const ConversationSkeleton = () => {
  return (
    <div className="relative flex w-full animate-pulse justify-between gap-[1rem] py-[1.6rem] pl-8 pr-[1.6rem] text-left">
      <div className="flex w-full items-start overflow-hidden px-4">
        <div className="flex items-center gap-x-4">
          {/* Image placeholder - matches getMessageImage() */}
          <div className="h-[7rem] w-[7rem] rounded bg-zinc-200"></div>
        </div>

        <div className="ml-5 w-full space-y-2 overflow-hidden">
          {/* Offer badges area - sometimes present */}
          <div className="flex items-center gap-2">
            <div className="h-[2.5rem] w-[6.4rem] rounded-xl bg-zinc-200"></div>
            <div className="h-[2.5rem] w-[8rem] rounded-xl bg-zinc-200"></div>
          </div>

          {/* Title and timestamp row */}
          <div className="line-clamp-2 w-full overflow-hidden">
            <div className="flex w-full justify-between">
              <div className="flex items-center gap-2">
                {/* Title */}
                <div className="h-[1.5rem] w-48 rounded bg-zinc-200"></div>
                {/* Flag icon placeholder */}
                <div className="h-5 w-5 rounded bg-zinc-200"></div>
              </div>
              {/* Timestamp */}
              <div className="h-[1.4rem] w-16 rounded bg-zinc-200"></div>
            </div>

            {/* Expert indicator - sometimes present */}
            <div className="mt-1 flex items-center gap-2">
              <div className="h-[1.4rem] w-12 rounded bg-zinc-200"></div>
              <div className="h-4 w-4 rounded bg-zinc-200"></div>
            </div>
          </div>

          {/* Topic line - getChatTopic() */}
          <div className="h-[1.4rem] w-2/5 rounded bg-zinc-200"></div>

          {/* Last message area */}
          <div className="my-2 flex w-full items-center justify-between gap-4">
            <div className="flex items-center gap-x-2">
              {/* Image icon placeholder - for when lastText === 'Image' */}
              <div className="h-8 w-8 rounded bg-zinc-200"></div>
              {/* Message text */}
              <div className="h-[1.5rem] w-64 rounded bg-zinc-200"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
